/**
 @author hjj
 @date 2020/6/29 10:01 下午
 */
import {getRouterResources} from "@/assets/js/basis";
import {getOption,getMapJson} from '@/assets/axios/mapAxio'
import {comLegend, comColor,openInfoWin,closeInfoWin} from "./comChart";
//展示默认地图
//type判断是什么类型的地图 0区域图，1点地图 2线地图 3.3d地图
export const clickDown = (data,mapData,params,tooltip,echart,nowChart,seriesArr,type,barData) => {
    let mapNameJson,url;
    //charts地图 自定义
    let geoMap =  {
        map: 'china',
        label: params.map.label,
        roam: true,
        zoom: params.map.zoom,
        emphasis:params.map.emphasis,
        itemStyle: params.map.itemStyle ,
    };
    //高德地图 自定义
    let amapMap = {
        maxPitch: 60,
        pitch: 10, //45 俯仰角
        viewMode: '3D',
        zoom: params.map.amapMap.zoom,
        expandZoomRange: true,
        mapStyle: 'amap://styles/'+ params.map.mapStyle, //地图主题
        center: params.map.amapMap.center.split(","), //中心点
        rotation: 0,  //顺时针旋转角度
        resizeEnable: true,
    };
    if(type===3){
        geoMap = {
            map: 'china',
            zlevel:0,
            itemStyle: {
                areaColor:params.map.itemStyle.areaColor,
                opacity: 1,
                borderWidth: 0.8,
                borderColor: params.map.itemStyle.borderColor,
            },
            label: {
                show: params.map.label.show,
                textStyle: {
                    color:params.map.label.color,
                    fontSize:params.map.label.fontSize,
                    backgroundColor:params.map.label.backgroundColor
                }
            },
            viewControl:params.map.viewControl,
            emphasis:params.map.emphasis,
        };
        amapMap = {
            pitch:45, // 地图俯仰角度，有效范围 0 度- 83 度
            mapStyle: 'amap://styles/'+ params.map.mapStyle, //地图主题
            zoom: params.map.zoom,
            viewMode:'3D',
            showBuildingBlock:true,
            center:[106.472605,39.992075],
        }
    }

    for(var key in mapData){
        if(data == mapData[key].name){
            if(mapData[key].level==="country"){
                mapNameJson='China';
                params.map.id = 100000;
            }
            if(mapData[key].level==="district"){
                if(mapData[key].parent.adcode=='110000' || mapData[key].parent.adcode=='120000' || mapData[key].parent.adcode=='310000') {
                    mapNameJson = 'county/' + mapData[key].adcode;
                    params.map.id = mapData[key].adcode;
                }
            }
            if(mapData[key].level==="province"){
                mapNameJson='province/'+mapData[key].adcode;
                params.map.id = mapData[key].adcode;
            }
            if(mapData[key].level==="city"){
                mapNameJson='citys/'+mapData[key].adcode;
                params.map.id = mapData[key].adcode;
            }
        }
    }
    url=data;
    $.get('/allMap/' + mapNameJson + '.json', (response) => {
        if(typeof(response)=='object'){
            if(data==='全国'){
                data = 'china';
            }
            echarts.registerMap(data, response);
            geoMap.map=data;
            if(type===0){
                seriesArr[0].map = data;
            }
            let option = {
                tooltip:tooltip,
                visualMap: nowChart.name === '地图' ? params.visualMap : null,
                amap: nowChart.name.search('GIS')!==-1 ? amapMap : null,
                geo: (nowChart.name.search('charts')!==-1 && nowChart.type !== '3Dmap' ) ? geoMap : null,
                geo3D:(nowChart.name.search('charts')!==-1 && nowChart.type == '3Dmap' )? geoMap : null,
                animation: false,
                series:seriesArr,
            };
            echart.clear();
            echart.setOption(option,true);
            if(nowChart.name.search('GIS')!==-1){
                var layer = echart.getModel().getComponent('amap').getLayer();
                var AMapmap = echart.getModel().getComponent('amap').getAMap();
                if(type===3){
                    let datav=barData;
                    var layer = new Loca.ScatterPointLayer({
                        map: AMapmap,
                        eventSupport: true
                    });
                    layer.on('mousemove', function (ev) {
                        // 事件类型
                        var type = ev.type;
                        // 当前元素的原始数据
                        var rawData = ev.rawData;
                        // 原始鼠标事件
                        var originalEvent = ev.originalEvent;
                        let mapinfo;
                        if(rawData.name){
                            mapinfo= {
                                '名称': rawData.name,
                                '位置': [rawData.value[0], rawData.value[1]],
                                '值': rawData.value[2]
                            }
                        }else{
                            mapinfo= {
                                '位置': [rawData.value[0], rawData.value[1]],
                                '值': rawData.value[2]
                            }
                        }
                        let displaybool;
                        if(params.tooltip.show){
                            displaybool='block';
                        }else{
                            displaybool='none';
                        }
                        $('.mapinfo').css({display:displaybool,'border-style':'solid','border-width':params.tooltip.borderWidth,'border-color':params.tooltip.borderColor,padding:params.tooltip.padding,color:params.tooltip.textStyle.color,background:params.tooltip.backgroundColor});
                        $('.mapinfo>table').css({'font-size':params.tooltip.textStyle.fontSize+'px','line-height':'20px'})
                        openInfoWin(AMapmap, originalEvent, mapinfo);
                    });
                    layer.on('mouseleave', function (ev) {
                        closeInfoWin();
                    });
                    layer.setData(datav, {
                        lnglat: 'value'
                    });
                    // 展示棱台的高度（随机高度）
                    var heights = [];
                    for(var i = 0; i < datav.length; i++){
                        if(datav[i].value[2]){
                            heights.push(datav[i].value[2]+ 100000);
                        }else{
                            heights.push(0);
                        }
                    }
                    layer.setOptions({
                        // 单位米
                        unit: 'meter',
                        style: {
                            radius: 50000,
                            height: function(data) {
                                return heights[data.index];
                            },
                            color: (res) => {
                                var mag = res.value.value[2];
                                if (mag >= 65) return '#DCE872';
                                else if (mag < 65 && mag >= 62) return '#10B3B0';
                                else if (mag < 62) return '#0B79B0';
                            },
                            opacity: 1,
                            // 旋转角度，单位弧度
                            rotate: Math.PI / 180 * 45
                        }
                    });
                    layer.render();
                }
                AMap.event.addListener(AMapmap, 'zoomend', function () {
                    params.map.amapMap.zoom = AMapmap.getZoom();
                    params.map.amapMap.center = AMapmap.getCenter().toString();
                });
                AMapmap.on('moveend', function () {
                    params.map.amapMap.zoom = AMapmap.getZoom();
                    params.map.amapMap.center = AMapmap.getCenter().toString();
                });
                layer.render = function() {
                    echart.setOption(option);
                }
            }
        }
    })
}
export const renderEvent=(echart,clickOut,mapData,params,tooltipPoint,nowChart,seriesArr,type)=>{
    let timeFn = null;
    echart.off('click');
    echart.on('click', (data) => {
        clearTimeout(timeFn);
        timeFn = setTimeout(function() {
            if(!clickOut[1]){
                clickOut[1]=data.name;
            }else if(!clickOut[2]){
                clickOut[2]=data.name;
            }
            clickDown(data.name, mapData,params,tooltipPoint,echart,nowChart,seriesArr,type);
        }, 240);
    });
    echart.getZr().on('dblclick',function(e){
        clearTimeout(timeFn);
        let urlName='';
        if(clickOut[2]){
            urlName=clickOut[1];
            clickOut[2]='';
        }else if(clickOut[1]){
            urlName=clickOut[0];
            clickOut[1]='';
        }
        clickDown(urlName, mapData,params,tooltipPoint, echart,nowChart,seriesArr,type);
    });
}
